import React from "react";

import {
  ContentLayout,
  SpaceBetween,
} from "@amzn/awsui-components-react/polaris";

import MedicalPanelData from "./MedicalPanelData";
import MedicalAuthorizationDocuments from "./MedicalAuthorizationDocuments";
import Stateforms from "./StateForms";

const WorkersCompensationDocuments = () => {
  return (
    <ContentLayout>
      <SpaceBetween direction="vertical" size="m">
        <MedicalPanelData />
        <MedicalAuthorizationDocuments />
        <Stateforms />
      </SpaceBetween>
    </ContentLayout>
  );
};
export default WorkersCompensationDocuments;
